module.exports = __webpack_public_path__ + "static/img/comment-count.b3cc3d0c.png";